import React, { useEffect, useState } from "react";
import { Notify, Utils } from "../../../utils";
import { Constant } from "../../../config";
import { CPFService } from "../../../_service/CPFService";
import { Loader, NavigateBack } from "../../../components";
import { Heading } from "../../appSettings/AppSettingsStyles";
import { LoaderContainer } from "../../../CommonStyles";

const IR8AMapping = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [mappingData, setMappingData] = useState([]);
  const [tableHeaders, setTableHeaders] = useState([]);

  const getIR8AMappingData = async () => {
    setIsLoading(() => true);
    try {
      const { status, data } = await CPFService._getIR8AMappingData();

      if (status === 200) {
        const responseData = data.data;
        // Handle new format with headers and data properties
        if (responseData?.headers && responseData?.data) {
          setTableHeaders(() => responseData.headers);
          setMappingData(() => responseData.data);
        }
      }
    } catch (error) {
      Utils.showErrorMessage(error);
    }
    setIsLoading(() => false);
  };

  useEffect(() => {
    getIR8AMappingData();
  }, []);

  return (
    <div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "1rem",
        }}
      >
        {/* <NavigateBack /> */}
        <Heading>
          {Utils.getTitleWithCompanyName("IR8A Built-in Items Mapping")}
        </Heading>
      </div>
      {isLoading ? (
        <LoaderContainer>
          <Loader />
        </LoaderContainer>
      ) : mappingData.length === 0 ? (
        <div
          style={{
            display: "flex",
            textAlign: "center",
            padding: "40px",
            color: "#666",
            fontSize: "1rem",
            justifyContent: "center",
            alignItems: "center",
            marginTop: "200px",
            fontWeight: 500,
          }}
        >
          No Data Available
        </div>
      ) : (
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            // marginTop: "20px",
          }}
        >
          <thead>
            <tr style={{ backgroundColor: "#f5f5f5" }}>
              {tableHeaders?.map((x: string) => (
                <th
                  style={{
                    border: "1px solid #ddd",
                    padding: "8px 12px",
                    textAlign: "left",
                    textTransform: "capitalize",
                  }}
                >
                  {formatHeading(x) || "-"}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {mappingData?.map((item: any, index: number) => (
              <tr
                key={index}
                style={{
                  backgroundColor: index % 2 === 0 ? "#fff" : "#f9f9f9",
                }}
              >
                {tableHeaders?.map((header, headerIndex) => (
                  <td
                    key={headerIndex}
                    style={{ border: "1px solid #ddd", padding: "8px 12px",  }}
                  >
                    {(item[header] === "ow" || item[header] === "aw") ? (item[header]?.toUpperCase()) : (item[header] || "-")}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default IR8AMapping;

const formatHeading = (str: string) => {
  return str
    .split("_")
    .map((word) => {
      if (word.toLowerCase() === "pdf") return "PDF";
      if (word.toLowerCase() === "ir8a") return "IR8A";
      if (word.toLowerCase() === "ow/aw") return "OW/AW";
      if (word.toLowerCase() === "aw") return "AW";
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(" ");
};
